import { toFixed } from '@lsfe/tools';
import { time } from './time';

// 格式化数据
export const formatData = (data, options = {}) => {
    const ret = { ...data };
    Object.entries(data)
    // eslint-disable-next-line no-unused-vars
        .filter(([k, v]) => k in options)
        .forEach(([k, v]) => {
            const option = options[k];
            const { type, defaultValue } = option;
            if (['number', 'date'].includes(type)) {
                if (v === '') {
                    ret[k] = defaultValue;
                } else {
                    ret[k] = +v;
                }
            }
        });
    return ret;
};

/**
 * [处理默认数据]
 * @param  {Object} data         [数据源]
 * @param  {String} key          [要处理的字段名]
 * @param  {any} defaultValue [默认值]
 * @param  {any} replaceValue [替换值]
 *
 * 比如 当数据是 '-1' 时, 显示为 '-'
 */
export const formatDefaultData = (data, key, defaultValue, replaceValue) => {
    const val = data[key];
    data[key] = val === defaultValue ? replaceValue : val;
};

/**
 * [金额格式化]
 * @param  {Object} data [数据源]
 * @param  {Array}  keys [数据中的金额字段名]
 * @param  {string} empty [当为空时的显示]
 * formatMoney({
 *     a: 'aaa',
 *     b: 123
 * }, ['b'])
 */
export const formatMoney = (data = {}, keys = [], empty = '-') => {
    keys.forEach((v) => {
        const val = +data[v];
        if (val < 0) {
            data[v] = empty;
        } else {
            data[v] = val ? (val / 1e2).toFixed(2) : empty;
        }
    });
};

/**
 * [格式化data中的日期]
 * @param  {Object} data       [数据源]
 * @param  {Object} timeOption [数据中的日期字段名以及其对应的格式化字符串]
 * @param  {string} empty [当为空时的显示]
 * timeOption: {
 *     key1: 'yyyy-MM-dd HH:mm',
 *     key2: 'yyyy-MM-dd'
 * }
 */
export const formatTime = (data, timeOption = {}, empty = '--') => {
    Object.entries(data).forEach(([k, v]) => {
        if (k in timeOption) {
            data[k] = +v <= 0 ? empty : time(v, timeOption[k]);
        }
    });
};

/**
 * 格式化小数
 * 展示规则：
 * 小于等于两位小数，展示两位小数，不足补0；
 * 大于两位小于等于四位小数，展示四位小数，不足补0
 * 如：
 * 0位小数：899，显示为：899.00
 * 1位小数：88.1，显示为：88.10
 * 2位小数：12.56，显示为：12.56
 * 3位小数：2.245，显示为：2.2450
 * 4位小数：1.1234，显示位：1.1234
 */
export const formatDecimal = (numberString = '') => {
    if (!Number.isNaN(Number(numberString))) {
        const realNumber = String(Number(numberString));
        // eslint-disable-next-line no-unused-vars
        const [int, dec = ''] = realNumber.split('.');
        if (dec.length <= 2) {
            return toFixed(realNumber, 2);
        }
        return toFixed(realNumber, 4);
    }
    return numberString;
};


/**
 * [将平铺的树形数据转换成树状数据结构]
 * @param  {Array} originData [原数据]
 * @param  {Object} option [key配置]
 * 示例:
 * originData: [{
      "parentId": 0,
      "level": 1,
      "leaf": false,
      "id": 100,
      "label": "水果汇总",
      "path": "xx"
    }]
 */
export const transformToTreeData = (originData, option = {}) => {
    const { parentIdKey = 'parentId', nodeIdKey = 'id' } = option;
    const result = [];
    originData.forEach((item1) => {
        const parentNode = originData.find((item2) => item2[nodeIdKey] === item1[parentIdKey]);
        if (parentNode && parentNode.children) {
            parentNode.children.push(item1);
        } else if (parentNode) {
            parentNode.children = [item1];
        } else {
            result.push(item1);
        }
    });
    return result;
};
